import { useEffect, useState } from "react";
import theme from "../theme";

export const SortArrow: React.FC<{
  id?: string; // 항목의 id
  state?: string; // 항목과 비교할 변수 state
}> = (props) => {
  const { id, state } = props;
  const [asc, setAsc] = useState(false);
  const [desc, setDesc] = useState(false);

  useEffect(() => {
    // 렌더시 비활성화 (화살표 여러개 생김 방지)
    setAsc(false);
    setDesc(false);
    if (id && state) {
      // 항목이 내림차순 정렬중인지 확인
      if (`${id} ASC` === state) {
        setAsc(true);
        setDesc(false);
        return;
      }
      // 항목이 오름차순 정렬중인지 확인
      if (`${id} DESC` === state) {
        setDesc(true);
        setAsc(false);
        return;
      }
    }
  }, [id, state]);

  return (
    <>
      {/* 기본아이콘 */}
      <div
        style={
          !state
            ? {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }
            : { display: " none" }
        }
      >
        <svg
          fill={theme.color.neutral_600}
          width="15"
          height="15"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17,14 C17.8092996,14 18.2680938,14.9010044 17.836059,15.5493995 L17.7682213,15.6401844 L12.7682213,21.6401844 C12.3950792,22.0879549 11.7283228,22.1178063 11.3160321,21.7297385 L11.2317787,21.6401844 L6.23177872,15.6401844 C5.71367776,15.0184632 6.11213562,14.0891988 6.88682851,14.0060047 L7,14 L17,14 Z M11.2317787,2.3598156 C11.6049208,1.91204508 12.2716772,1.88219371 12.6839679,2.2702615 L12.7682213,2.3598156 L17.7682213,8.3598156 C18.2863222,8.98153675 17.8878644,9.91080124 17.1131715,9.99399528 L17,10 L7,10 C6.19070043,10 5.73190618,9.09899556 6.16394105,8.45060047 L6.23177872,8.3598156 L11.2317787,2.3598156 Z" />
        </svg>
      </div>
      {/* 내림차순 */}
      <div
        style={
          asc ? { display: "block", height: "15px" } : { display: "none" }
        }
      >
        <svg
          stroke={theme.color.neutral_600}
          fill={theme.color.neutral_600}
          strokeWidth="0"
          version="1.2"
          baseProfile="tiny"
          viewBox="0 0 24 24"
          height="15"
          width="15"
        >
          <path d="M5.8 9.7l6.2 6.3 6.2-6.3c.2-.2.3-.5.3-.7s-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3h-11c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7s.1.5.3.7z"></path>
        </svg>
      </div>
      {/* 오름차순 */}
      <div
        style={
          desc ? { display: "block", height: "15px" } : { display: "none" }
        }
      >
        <svg
          stroke={theme.color.neutral_600}
          fill={theme.color.neutral_600}
          strokeWidth="0"
          version="1.2"
          baseProfile="tiny"
          viewBox="0 0 24 24"
          height="15"
          width="15"
        >
          <path d="M18.2 13.3l-6.2-6.3-6.2 6.3c-.2.2-.3.5-.3.7s.1.5.3.7c.2.2.4.3.7.3h11c.3 0 .5-.1.7-.3.2-.2.3-.5.3-.7s-.1-.5-.3-.7z"></path>
        </svg>
      </div>
    </>
  );
};
